var ErrorCodes = /* @__PURE__ */ ((ErrorCodes2) => {
  ErrorCodes2["loginRequired"] = "login_required";
  ErrorCodes2["interactionRequired"] = "interaction_required";
  ErrorCodes2["noResponse"] = "no_response";
  ErrorCodes2["invalidState"] = "invalid_state";
  ErrorCodes2["invalidNonce"] = "invalid_nonce";
  ErrorCodes2["invalidIdToken"] = "invalid_id_token";
  ErrorCodes2["idTokenUndefined"] = "id_token_undefined";
  ErrorCodes2["accessTokenUndefined"] = "access_token_undefined";
  ErrorCodes2["expiresInUndefined"] = "expires_in_undefined";
  ErrorCodes2["refreshAccessTokenTimeout"] = "refresh_access_token_timeout";
  return ErrorCodes2;
})(ErrorCodes || {});
function isErrorCode(code) {
  return Object.values(ErrorCodes).includes(code);
}
export {
  ErrorCodes,
  isErrorCode
};
//# sourceMappingURL=interface.js.map
